import React, { useCallback, useState } from 'react';
import useFromAsset from '../../hooks/use-from-asset.js';
import useFeeDetails from '../../hooks/use-fee-details.js';
import { useQuoteContext } from '../../context/quote.js';
const FeeDetails = ({ Component, className, onPress, style, }) => {
    const [fromAsset] = useFromAsset();
    const quote = useQuoteContext();
    const [fiatMode, setFiatMode] = useState(false);
    const { fee, feeFiat } = useFeeDetails();
    const handlePress = useCallback(() => {
        onPress?.({
            fee,
            feeAsset: fromAsset.feeAsset,
            providerName: quote.value?.providerName,
            feeFiat,
        });
    }, [fee, feeFiat, fromAsset.feeAsset, onPress, quote.value?.providerName]);
    const handleFiatModePress = () => {
        setFiatMode(!fiatMode);
    };
    const valueToDisplay = fiatMode ? feeFiat : fee;
    if (Component) {
        return (React.createElement(Component, { visible: !!fee, value: valueToDisplay, fiatMode: fiatMode, feeAsset: fromAsset.feeAsset, className: className, style: style, onPress: handlePress, onFiatModePress: handleFiatModePress }));
    }
    return null;
};
export default FeeDetails;
